let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eyVU5")).then(() => parcelRequire('4f2zd'));